<template>
  <div :style="{ 'margin-top': margin }">
    <v-layout row wrap justify-space-between>
      <v-flex xs2 class="text-xs-left">
        <v-btn @click.stop="goLeft" flat icon color="white">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs4 class="text-xs-center">
        <v-btn @click.stop="toToday" flat small color="white">{{displayMonth}}</v-btn>
      </v-flex>
      <v-flex xs2 class="text-xs-right">
        <v-btn :disabled="currentWeek === activeWeek" @click.stop="goRight" flat icon color="white">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <ul id="calendar-list">
      <li v-ripple v-for="(day, index) in daysOfWeek" :class="[{'primary': isActive(day)}, {'disabled': isAfter(day)}, {'dot': hasEvent(day)}]" @click.stop="viewDay(day)" :key="index">
        <span v-if="activeWeek === currentWeek && today.toString() === day.toString()">Today</span>
        <span v-else >{{day | format_day}}</span>
      </li>
    </ul>
  </div>

</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      today: moment().startOf('day'),
      dateContext: moment().startOf('day'),
      currentMonth: moment().format('MM'),
      currentWeek: moment().isoWeek()
    }
  },
  props: ['events', 'user', 'marginTop'],
  mounted () {
    this.$emit('updateActiveDate', moment(this.dateContext))
  },
  methods: {
    goLeft: function () {
      this.dateContext = moment(this.dateContext).subtract(7, 'days')
      if (this.user.commenced_at) {
        var commenced = moment.unix(this.user.commenced_at)
        if (moment(this.dateContext).isBefore(commenced)) {
          this.dateContext = commenced
        }
      }
      this.$emit('updateActiveDate', this.dateContext)
    },
    goRight: function () {
      this.dateContext = moment(this.dateContext).add(7, 'days')
      if (moment(this.dateContext).isAfter(this.today)) {
        this.dateContext = moment(this.today)
      }
      this.$emit('updateActiveDate', this.dateContext)
    },
    toToday: function () {
      this.dateContext = moment().startOf('day')
      this.$emit('updateActiveDate', this.dateContext)
    },
    viewDay: function (day) {
      this.dateContext = moment(day)
      this.$emit('updateActiveDate', this.dateContext)
    },
    isActive: function (day) {
      if (day.toString() === moment(this.dateContext).toString()) {
        return true
      } return false
    },
    isAfter: function (day) {
      if (moment(day).isAfter(this.today)) {
        return true
      } return false
    },
    hasEvent: function (day) {
      if (this.events) {
        var activeEvents = this.events.find(function (event) {
          return moment.unix(event.created_at).isSame(day, 'day')
        })
      }
      if (activeEvents) {
        return true
      } return false
    }
  },
  computed: {
    startOfWeek: function () {
      var t = this
      var firstDay = moment(t.dateContext).startOf('isoWeek').format('DD')
      return firstDay
    },
    daysOfWeek: function () {
      var t = this
      var firstDay = moment(t.dateContext).startOf('isoWeek')
      var lastDay = moment(firstDay).add(6, 'd')
      var day = firstDay
      var dates = []
      while (day <= lastDay) {
        dates.push(day)
        day = day.clone().add(1, 'd')
      }
      return dates
    },
    activeWeek: function () {
      return moment(this.dateContext).isoWeek()
    },
    startWeek: function () {
      if (this.user.commenced_at) {
        return moment.unix(this.user.commenced_at).isoWeek()
      } else {
        return null
      }
    },
    displayMonth: function () {
      return moment(this.dateContext).format('MMMM YY')
    },
    margin () {
      if (this.marginTop) {
        return this.marginTop
      } else {
        return '-48px'
      }
    }
  }
}
</script>
<style scoped>
  #calendar-list {
    height: 66px;
    width: 100%;
    list-style-type: none;
    padding: 0 16px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    background-color: #E0E0E0;
  }
  #calendar-list li {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    height: 100%;
    padding: 8px 0;
    margin: auto;
    white-space: pre-line;
    width: 100%;
    cursor: pointer;
  }
  #calendar-list li.dot::after {
    content: '.';
    font-size: 50px;
    line-height: 42px;
    position: absolute;
    bottom: 0;
    bottom: 4px;
    left: 0;
    right: 0;
  }
  #calendar-list li.primary {
    color: #fff;
  }
  #calendar-list li.disabled {
    pointer-events: none;
  }
  #calendar-list li span {
    font-size: 12px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/calendar-buttons.vue